import rentalHtml from './rental.component.html';
import { Polish } from 'flatpickr/dist/l10n/pl.js';

class RentalController {
    constructor($scope, $sce, RentalService) {
        'ngInject';

        this.$scope = $scope;
        this.$sce = $sce;
        this.service = RentalService;

        //const tomorrow = new Date();
        //tomorrow.setDate(new Date().getDate() + 1);

        const today = new Date();
        today.setDate(new Date().getDate());

        this.rentalPeriodCalendar = null;
        this.renatlPeriod = null;
        this.rentalPeriodCalendarConfig = {
            dateFormat: 'd.m.Y',
            locale: Polish,
            minDate: today,
            disable: [],
            onClose: function(selectedDates, dateStr, instance) {
                let dateFrom = new Date(selectedDates[0]);
                let dateTo = new Date(selectedDates[1]);

                RentalService.userData.rentalPeriodFrom = dateFrom.getFullYear() + '-' + (dateFrom.getMonth() + 1) + '-' + dateFrom.getDate();
                RentalService.userData.rentalPeriodTo = dateTo.getFullYear() + '-' + (dateTo.getMonth() + 1) + '-' + dateTo.getDate();

                RentalService.calculatePrice();
            }
        };
        this.rentalPeriodCalendarConfigChangeDisableDates = false;
    }

    $onInit() {
        if (!this.service.loaded && !this.service.loading) {
            this.service.load().then(function(response) {
                this.$scope.$watch(
                    () => this.rentalPeriodCalendar,
                    () => {
                        if (this.rentalPeriodCalendarConfigChangeDisableDates === false) {
                            this.rentalPeriodCalendarConfigChangeDisableDates = true;
                            this.rentalPeriodCalendar.set('disable', response.product.disableDates);
                        }
                    }
                );
            }.bind(this));
        }
    }

    rentalPeriodCalendarPostSetup(rentalPeriodCalendar) {
        this.rentalPeriodCalendar = rentalPeriodCalendar;
    }

    setShipment(shipment) {
        this.service.setShipment(shipment);

        this.service.price.shipment = shipment.price;
    }

    setPayment(payment) {
        this.service.setPayment(payment);
    }

    submit() {
        this.service.submit().then(function() {
            this.service.step = 2;
        }.bind(this));
    }

    submitWithError() {
        this.service.showAllErrors = true;
    }
}

let rentalComponent = {
    bindings: {
        'productSlug': '<'
    },
    template: rentalHtml,
    controller: RentalController
};

export default rentalComponent;